import { Typography } from '@mui/material';
import type React from 'react';
import AkomiDialog from 'src/components/dialogs/AkomiDialog';
import AkomiDialogActions from 'src/components/dialogs/AkomiDialogActions';

interface GroupsDeleteDialogProps {
  name?: string;
  onClose: () => void;
  onOk: () => void;
}

const GroupsDeleteDialog = ({ name = '', onClose, onOk }: GroupsDeleteDialogProps): React.ReactElement => {
  return (
    <AkomiDialog
      title="Delete"
      maxWidth="xs"
      open={true}
      onClose={onClose}
      actions={
        <AkomiDialogActions variant="delete-cancel" primaryLabel="Delete" onPrimary={onOk} onSecondary={onClose} />
      }
    >
      <Typography>Are you sure you want to delete the group {name}?</Typography>
    </AkomiDialog>
  );
};

export default GroupsDeleteDialog;
